// function to get Nova conversation id and Nova Conversation title.

// conversation Id
export const getNovaConversationId = (state) => {
  const conversationIdFromState =
    state?.aiFeatures?.goalsCreateWithNovaAI?.conversation?.id;
  if (conversationIdFromState) return conversationIdFromState;

  const employeeId = state?.user?.employeeId;
  if (!employeeId) return null;

  const data = JSON.parse(
    localStorage.getItem("nova_conversation_data") || "{}"
  );
  return data[employeeId]?.id || null;
};

// conversation Title

export const getNovaConversationTitle = (state) => {
  const newTitle = state?.aiFeatures?.goalsCreateWithNovaAI.conversation?.name;
  if (newTitle) return newTitle;

  const employeeId = state?.user?.employeeId;
  if (!employeeId) return null;

  const data = JSON.parse(
    localStorage.getItem("nova_conversation_data") || "{}"
  );
  return data[employeeId]?.title || null;
};

export const selectChatMessages = (state, conversationId) =>
  state.aiFeatures.goalsCreateWithNovaAI.chatMessages[conversationId] || [];
